import { WithMongooseProps } from '@runelab/odin-common'
import { User } from 'types/user'
import { ChatMessage } from 'types/chat-message'
import { Ticket } from 'types/ticket'
import { Area } from 'types/area'

export enum ChatResponseModeEnum {
  BOT = 'bot',
  OPERATOR = 'operator',
}

export enum ChatRoleEnum {
  BOT = 'bot',
  OPERATOR = 'operator',
  USER = 'user',
  GUEST = 'guest',
  TENANT_ADMIN = 'tenant_admin',
  ADMIN = 'admin',
  SUPERVISOR = 'supervisor',
}

export type Participant = {
  userId: string
  user?: User
  isAdmin: boolean
  role: ChatRoleEnum
  lastReadTimestamp: number
}

export type Chat = WithMongooseProps<{
  userId?: string
  user?: User
  name?: string
  areaIds: string[]
  areas?: Area[]
  responseMode: ChatResponseModeEnum
  materializedCategoryName: string
  lastMessage?: ChatMessage
  participants: Participant[]
  ticket?: Ticket
  /** Set on notebook chats (POST chats/bot with agentId): the chat is locked to this single agent. */
  agentId?: string
  /** Notebook mode: host entity the notebook is about (e.g. a customer id); scopes the history. */
  contextId?: string
}>
